/** @format */

import { combineReducers } from 'redux';
import createReducer from "../../BasicReducer";

export default combineReducers({
  state: createReducer('oneUpReview.state', {})
});